module.exports = __webpack_public_path__ + "img/joinZigZag3.9b6df872.svg";